module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp13_6000.8a2a49ba.png";